<template>
  <el-dialog :visible.sync="dialogVisible" width="30%" title="请完成安全验证" show-close :close-on-click-modal="false" @close="closeHandle">
    <div class="container" :style="{ width: 400 + 'px' }">
      <div class="img-box" ref="imgBox" :style="{ width: 400 + 'px', height: 200 + 'px' }">
        <img
          :src="'data:image/png;base64,' + validateData.SrcImage"
          alt=""
          :style="{ width: validateData.SrcImageWidth + 'px', height: validateData.SrcImageHeight + 'px' }" />
        <div class="pt" ref="ptRef" :style="{ top: validateData.YPosition + 'px' }">
          <img :src="'data:image/png;base64,' + validateData.CutImage" alt="" />
        </div>
        <div class="message" v-if="isFail">验证失败</div>
      </div>

      <div class="hk-box">
        <div class="color" ref="colorRef"></div>
        <div class="hk" ref="hkRef" :style="{ backgroundColor: isFail ? '#ff6700' : '#0b62f0' }">
          <i class="el-icon-d-arrow-right" v-if="!isClick"></i>
          <i class="el-icon-check" v-if="isSuccess"></i>
          <i class="el-icon-close" v-if="isFail"></i>
        </div>
        <span class="hint" v-if="!isClick">向右滑动完成验证</span>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import myHttp from '../untils/port'
export default {
  name: 'sliderVerification',
  props: {
    dialog: Boolean,
    phone: String,
  },
  data() {
    return {
      validateData: {
        SrcImageHeight: 0,
        YPosition: 0,
        SrcImage: '',
        CutImage: '',
        SrcImageWidth: 0,
      },
      rect: {},
      isClick: false,
      isFail: false,
      isMobile: false,
      isEnd: false,
      isSuccess: false,
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.dialog
      },
      set(newValue) {
        this.$emit('update:dialog', newValue)
      },
    },
  },
  methods: {
    async showVerify() {
      try {
        const params = {
          phoneNum: this.phone,
        }
        const { data: res } = await myHttp.getLoginVerifyImg(params)
        this.validateData = res
      } catch (e) {
        this.$message({ type: 'error', message: e })
      }
    },
    init() {
      this.rect = this.$refs.imgBox.getBoundingClientRect()
      console.log('reac', this.rect)

      this.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

      if (this.isMobile) {
        this.$refs.hkRef.addEventListener('touchstart', this.start)
      } else {
        this.$refs.hkRef.addEventListener('mousedown', this.start)
      }
    },
    start() {
      this.isClick = true
      if (!this.isEnd) {
        if (this.isMobile) {
          window.addEventListener('touchmove', this.move)
          window.addEventListener('touchend', this.end)
        } else {
          window.addEventListener('mousemove', this.move)
          window.addEventListener('mouseup', this.end)
        }
      }
    },
    move(e) {
      let left = 0

      if (this.isMobile) {
        left = e.changedTouches[0].clientX - this.rect.left
      } else {
        left = e.clientX - this.rect.left
      }

      if (left <= 0) left = 0
      if (left >= this.rect.width - 50) left = this.rect.width - 50
      this.$refs.hkRef.style.transition = ''
      this.$refs.hkRef.style.left = left + 'px'
      this.$refs.ptRef.style.transition = ''
      this.$refs.ptRef.style.left = left + 'px'
      this.$refs.colorRef.style.transition = ''
      this.$refs.colorRef.style.width = left + 25 + 'px'
    },
    async end(e) {
      this.isEnd = true
      let endX = 0

      if (this.isMobile) {
        endX = e.changedTouches[0].clientX - this.rect.left
      } else {
        endX = e.clientX - this.rect.left
      }

      if (this.isMobile) {
        window.removeEventListener('touchmove', this.move)
        window.removeEventListener('touchend', this.end)
      } else {
        window.removeEventListener('mousemove', this.move)
        window.removeEventListener('mouseup', this.end)
      }

      try {
        const params = {
          phoneNum: this.phone,
          moveEnd_X: endX,
        }
        const { data: res } = await myHttp.postLoginImageValidate(params)

        if (res.success) {
          this.isSuccess = true
          let timer = setTimeout(() => {
            this.isSuccess = false
            this.isClick = false
            this.resetStyle()
            this.$emit('success', endX)
            this.isEnd = false
            this.dialogVisible = false
            clearTimeout(timer)
          }, 1000)
        } else {
          this.isFail = true
          let timer = setTimeout(() => {
            this.isFail = false
            this.isClick = false
            this.resetStyle()
            this.showVerify()
            this.isEnd = false
            clearTimeout(timer)
          }, 1000)
        }
      } catch (e) {
        this.$message({ type: 'error', message: e })
      }
    },
    resetStyle() {
      this.$refs.hkRef.style.transition = 'left 0.4s'
      this.$refs.hkRef.style.left = 0 + 'px'
      this.$refs.ptRef.style.transition = 'left 0.4s'
      this.$refs.ptRef.style.left = 0 + 'px'
      this.$refs.colorRef.style.transition = 'width 0.4s'
      this.$refs.colorRef.style.width = 0 + 'px'
    },
    closeHandle() {
      this.resetStyle()
      this.isEnd = false
      this.isClick = false
    },
  },
  watch: {
    dialog(newVal) {
      if (newVal) {
        this.showVerify()
        this.$nextTick(() => {
          this.init()
        })
      }
    },
  },
}
</script>

<style scoped lang="less">
.container {
  user-select: none;
  width: 400px;
  margin: 0 auto;
}

.img-box {
  user-select: none;
  position: relative;

  & > img {
    display: block;
    width: 100%;
    height: 100%;
  }
}

.pt,
.hk {
  position: absolute;
  width: 50px;
  height: 50px;
}

.pt {
  user-select: none;
  top: 40%;
  left: 0;

  & > img {
    display: block;
    width: 100%;
    height: 100%;
  }
}

.hint {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.ok {
  user-select: none;
  width: 50px;
  height: 50px;
  position: absolute;
  top: 40%;
  left: 200px;
  background-color: blue;
}

.hk {
  display: flex;
  justify-content: center;
  align-items: center;
  user-select: none;
  top: 0;
  left: 0;
  border-radius: 50px;
  background-color: #0b62f0;
  box-shadow: 0 0 10px 8px rgba(0, 0, 0, 0.1);

  & > i {
    pointer-events: none;
    user-select: none;
    font-size: 24px;
    color: #fff;
  }
}

.color {
  user-select: none;
  width: 0;
  height: 50px;
  border-top-left-radius: 50px;
  border-bottom-left-radius: 50px;
}

.message {
  user-select: none;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  padding: 10px 20px;
  background-color: rgba(0, 0, 0, 0.5);
  box-sizing: border-box;
  color: #fff;
  z-index: 9;
}

.hk-box {
  user-select: none;
  position: relative;
  width: 100%;
  height: 50px;
  margin-top: 10px;
  background-color: #f5f5f5;
  border-radius: 50px;
}

::v-deep .el-dialog__body {
  padding: 1vw !important;
}

.dialog-title-custom {
  display: flex;
  justify-content: space-between;

  & span:nth-child(2) {
    font-size: 1vw;
  }
}
</style>
